// TODO: https://www.npmjs.com/package/i18next ?

import de from './i18n/de';
import en from './i18n/en';

const DEFAULT_LANGUAGE = 'en';
let documentLanguage =
	(typeof document !== 'undefined' &&
		document.documentElement &&
		document.documentElement.lang) ||
	DEFAULT_LANGUAGE;

// Remove region from language code if present
documentLanguage = documentLanguage.replace(/-.*$/, '');

const DICTIONARY = {en: en, de: de};

export function getDocumentLanguage() {
	return documentLanguage;
}

export function translate(key, language = documentLanguage) {
	if (!DICTIONARY[language]) {
		language = DEFAULT_LANGUAGE;
	}

	return DICTIONARY[language][key];
}
